import ControlArea from "components/Layout/ControlArea";
import React, { useEffect } from "react";
import Table from "./Table";
import shareIcon from "assets/svgs/categories.svg";
import { useDispatch } from "react-redux";
import { getCategories } from "store/actions";
const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  return (
    <>
      <div className="users-wrap">
        <ControlArea
          btnTxt="اضافة تصنيف جديد"
          cardTxt="التصنيفات"
          icon={shareIcon}
          url="/categories/add"
        />
        <Table />
      </div>
    </>
  );
};

export default Index;
